import React, { useContext, useMemo } from 'react';
import { Box, FormControl, InputLabel, OutlinedInput } from '@mui/material'
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _, { Dictionary } from 'lodash';
import { getParams } from '../utils';
import { DocContext } from '../Documentation';
import { PathContext } from './Methods';

const Param: React.FC<{
    param: OpenAPI.ParameterObject;
    value?: string;
    onChange: (val: string) => void;
}> = ({ param, value, onChange }) => {
    const { name } = param;

    return (
        <Box sx={{ mt: 1, mb: 1 }}>
            <FormControl
                size='small'
            >
                <InputLabel htmlFor={'field-' + name}>{name}</InputLabel>
                <OutlinedInput
                    id={'field-' + name}
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    label={name}
                />

            </FormControl>
        </Box>
    );
};

export interface ParametersProps {
    operationObject: OpenAPI.OperationObject;
    values: Dictionary<string>;
    onChange: (key: string, val: string) => void;
}

const Parameters: React.FC<ParametersProps> = ({ operationObject, values, onChange }) => {
    const { parameters } = operationObject;
    const document: OpenAPI.Document = useContext(DocContext)!;
    const pathCtx = useContext(PathContext)!;
    const { pathItemObject } = pathCtx;

    const params: OpenAPI.ParameterObject[] = useMemo(
        () => getParams(pathItemObject, operationObject, document),
        [pathItemObject, parameters, document]
    );

    const handleChange = (param: OpenAPI.ParameterObject) => (value: string) => onChange(param.name, value);

    return (
        <Box>
            {
                _.each(params).map((param, index) => (
                    <Param
                        key={index}
                        param={param}
                        value={values[param.name]}
                        onChange={handleChange(param)}
                    />
                ))
            }
        </Box>
    );
};

export default Parameters;
